<script>
	import { cn } from "./cn.js";
	import { createEventDispatcher } from "svelte";
	import { fade, fly } from "svelte/transition";

	// 사이드 드로어(shadcn Sheet 대응). open으로 표시, 오버레이/닫기/Esc 시 close 이벤트.
	export let open = false;
	export let title = "";
	export let side = "right"; // right | left
	let className = "";
	export { className as class };

	const dispatch = createEventDispatcher();
	const close = () => dispatch("close");
	const onKeydown = (e) => {
		if (open && e.key === "Escape") close();
	};

	// 호출부가 폭을 지정하면 기본 max-w 를 뺀다 — cn 은 tailwind-merge 가 아니라 단순 결합이라
	// 두 클래스가 함께 남고, 스타일시트 순서로 승자가 갈린다(Dialog 와 같은 가드).
	$: hasMaxW = /(?:^|\s)tw-max-w-/.test(className);
	$: flyX = side === "left" ? -420 : 420;
	$: sideClass = side === "left" ? "tw-left-0" : "tw-right-0";
</script>

<svelte:window on:keydown={onKeydown} />

{#if open}
	<!-- ⚠️ `!tw-m-0` — 부모가 `tw-space-y-*` 를 쓰면 `position:fixed` 인 이 요소에도 margin-top 이
	     붙어 오버레이가 화면 위쪽을 못 덮는다(Dialog.svelte 주석에 자세히). -->
	<div class="tw-fixed tw-inset-0 tw-z-[1000] !tw-m-0">
		<!-- 오버레이: 클릭 시 닫힘(button이라 키보드 접근 가능) -->
		<button
			type="button"
			class="tw-absolute tw-inset-0 tw-cursor-default tw-bg-black/50"
			aria-label="닫기"
			on:click={close}
			transition:fade={{ duration: 150 }}
		/>
		<div
			class={cn(
				"tw-absolute tw-top-0 tw-bottom-0 tw-flex tw-w-full tw-flex-col tw-bg-background tw-shadow-xl",
				hasMaxW ? "" : "tw-max-w-[420px]",
				sideClass,
				className,
			)}
			transition:fly={{ x: flyX, duration: 220 }}
		>
			<div class="tw-flex tw-items-center tw-justify-between tw-border-b tw-border-border tw-px-5 tw-py-4">
				<slot name="header">
					<h2 class="tw-text-base tw-font-semibold tw-text-foreground">{title}</h2>
				</slot>
				<button
					type="button"
					class="tw-cursor-pointer tw-text-muted-foreground hover:tw-text-foreground"
					on:click={close}
					aria-label="닫기">✕</button
				>
			</div>
			<div class="tw-flex-1 tw-overflow-y-auto tw-p-5">
				<slot />
			</div>
			{#if $$slots.footer}
				<div class="tw-flex tw-justify-end tw-gap-2 tw-border-t tw-border-border tw-px-5 tw-py-4">
					<slot name="footer" />
				</div>
			{/if}
		</div>
	</div>
{/if}
